module.exports = __webpack_public_path__ + "img/science-5-en.dc574855.png";